import type { Monaco } from "@monaco-editor/react";

/**
 * Define custom theme to match the old @textea/json-viewer look
 * @param monaco The Monaco instance
 */
export const defineCustomTheme = (monaco: Monaco): void => {
  monaco.editor.defineTheme("json-viewer-light", {
    base: "vs", // Use the light VS theme as a base
    inherit: true,
    rules: [
      { token: "string.key.json", foreground: "0451A5", fontStyle: "bold" },
      { token: "string.value.json", foreground: "A31515" },
      { token: "number", foreground: "098658" },
      { token: "keyword.json", foreground: "0000FF" },
      { token: "delimiter.bracket.json", foreground: "000000" },
      { token: "delimiter.array.json", foreground: "000000" },
      { token: "delimiter.comma.json", foreground: "000000" },
      { token: "delimiter.colon.json", foreground: "000000" },
      { token: "error", foreground: "FF0000", fontStyle: "bold" },
    ],
    colors: {
      "editor.background": "#FFFFFF",
      "editor.foreground": "#000000",
      "editorLineNumber.foreground": "#999999",
      "editor.lineHighlightBackground": "#F0F0F0",
      "editorCursor.foreground": "#000000",
      "editor.selectionBackground": "#ADD6FF",
      "editor.inactiveSelectionBackground": "#E5EBF1",
    },
  });
};
